<template>
  <div class="dashboard-widget-news">
    <div class="inner-box">
      <strong class="title">
        <a href="/news">What's New</a>
      </strong>
      <div class="dashboard-widget-news-slider-wrapper" @mouseenter="stopSlider" @mouseleave="startSlider">
        <div
          class="news-posts"
          :style="{
            transform: `translateX(-${slider_current_index * (100 / items_per_slide)}%)`,
            transition: isResetting ? 'none' : 'transform 0.5s ease'
          }"
          @transitionend="handleTransitionEnd"
        >
          <div
            class="news-post"
            v-for="(news_post, index) in clonedNewsPosts"
            :key="index"
          >
            <a :href="`/news/${news_post.id}`">
              <div class="news-post-image">
                <img :src="`${$aws_bucket_url}${news_post.main_image_url}`">
              </div>
              <div class="news-post-content">
                <div class="post-title">{{ news_post.title }}</div>
                <div class="date">Posted: {{ news_post.formatted_publish_at }}</div>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="slider-nav mb-3">
        <div
          v-for="(_, index) in news_posts"
          :key="index"
          class="slider-nav-item"
          :class="{ active: index === realIndex }"
          @click="goToSlide(index)"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['news_posts'],
  data() {
    return {
      slider_current_index: 0,
      realIndex: 0,
      slider_timer: null,
      items_per_slide: 3,
      isTransitioning: false,
      isResetting: false,
    };
  },
  computed: {
    clonedNewsPosts() {
      return [
        ...this.news_posts.slice(-this.items_per_slide),
        ...this.news_posts,
        ...this.news_posts.slice(0, this.items_per_slide)
      ];
    },
    totalSlides() {
      return this.news_posts.length;
    }
  },
  mounted() {
    this.slider_current_index = this.items_per_slide;
    this.startSlider();
  },
  methods: {
    startSlider() {
      this.stopSlider();
      this.slider_timer = setInterval(() => {
        this.nextSlide();
      }, 3000);
    },
    stopSlider() {
      if (this.slider_timer) {
        clearInterval(this.slider_timer);
        this.slider_timer = null;
      }
    },
    nextSlide() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.slider_current_index++;

      setTimeout(() => {
        if (this.slider_current_index >= this.totalSlides + this.items_per_slide) {
          this.isResetting = true;
          this.slider_current_index = this.items_per_slide;
          setTimeout(() => (this.isResetting = false), 50);
        }
        this.updateRealIndex();
      }, 500);
    },
    goToSlide(index) {
      if (this.isTransitioning) return;
      this.isTransitioning = true;
      this.realIndex = index;
      this.slider_current_index = index + this.items_per_slide;
    },
    handleTransitionEnd() {
      this.isTransitioning = false;

      if (this.slider_current_index >= this.totalSlides + this.items_per_slide) {
        this.isResetting = true;
        this.slider_current_index = this.items_per_slide;
        setTimeout(() => (this.isResetting = false), 50);
      } else if (this.slider_current_index < this.items_per_slide) {
        this.isResetting = true;
        this.slider_current_index = this.totalSlides + this.items_per_slide - 1;
        setTimeout(() => (this.isResetting = false), 50);
      }

      this.updateRealIndex();
    },
    updateRealIndex() {
      this.realIndex =
        (this.slider_current_index - this.items_per_slide + this.totalSlides) %
        this.totalSlides;
    }
  }
};
</script>
